import { concatJson, loadJsonData } from "./fjk.utils";

export function renderTopicsList() {

    const topics_limit = {
        "toppage": 5,
        "topics": 20
    }
  const data_file = [
    "/assets/data/topics.json",
    "/assets/data/topics_projects.json",
  ];

  const result = concatJson(data_file);

  console.log(result);

  let onelineinformation = $(".info_last_oneline");
  let onelineinformation_html = "";

  onelineinformation_html += onlineInformation(result.data[0]);
  onelineinformation.html(onelineinformation_html).hide().show();

  let topics_area_toppage = $("#topics__list__toppage");
  let topics_area_toppage_html = "";

  for (let i = 0; i < topics_limit.toppage; i++) {
    const elm = result.data[i];

    topics_area_toppage_html += genTopicsList(elm);

    // console.log("data",elm)
  }

  topics_area_toppage.html(topics_area_toppage_html);
  console.log(topics_area_toppage);

  let topics_area_topicspage = $(".topics__list__topicspage");
  let topics_area_topicspage_html = "";

  for (let i = 0; i < topics_limit.topics; i++) {
    const elm = result.data[i];

    topics_area_topicspage_html += genTopicsList(elm);

    // console.log("data",elm)
  }

  topics_area_topicspage.html(topics_area_topicspage_html);
//    console.log(topics_area_topicspage, topics_area_topicspage_html);

  
//   return result;
}

function onlineInformation(data){

      let data_type_class = "";
      let append_text = "";
      if (data.type === "topics") {
        data_type_class = "cat_label__info";
      }
      if (data.type === "projects") {
        data_type_class = "cat_label__project";
        append_text = "を施工実績に追加しました";
      }

  
  const item = `
               <dt class="date">${data.date}</dt> 
               <dd class="category"><span class="cat_label ${data_type_class}">${data.type_label}</span></dd>
               <dd class="title"><a href="${data.url}">${data.title}${append_text}</a></dd>
  `;


  return item;
}

function genTopicsList(data){
    let data_type_class = "";
    let append_text = "";
    if (data.type === "topics") {
        data_type_class = "cat_label__info";
    }
    if (data.type === "projects") {
        data_type_class = "cat_label__project";
        append_text = "を施工実績に追加しました"
    }
    
    const topicsItem = `<div class="topics__listitem">
      <p class="date">${data.date}</p>
      <p class="category">
        <span class="cat_label ${data_type_class}">${data.type_label}</span>
      </p>
      <p class="content">
        <a href="${data.url}">${data.title}${append_text}</a>
      </p>
    </div>`;

    return topicsItem;
}